// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.wiki-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    color: #333;
    font-family: Arial, sans-serif;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #fff;
  }
  
  /* Header */
  .wiki-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  /* Title */
  .wiki-title {
    font-size: 1.5rem;
    margin: 0;
    color: #007bff;
  }
  
  /* Image Placeholder */
  .wiki-image-placeholder {
    flex: 0 0 50%;
    height: 80px;
    background-color: #e9ecef;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #888;
    font-size: 0.9rem;
    border-radius: 5px;
  }
  
  /* Infobox */
  .wiki-infobox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 0.9rem;
    margin-bottom: 10px;
    gap: 10px;
  }
  
  /* Content Grid */
  .wiki-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  
  /* Section Styling */
  .wiki-section {
    background-color: #f8f8f8;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 0.9rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Wiki.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,WAAW;EACX;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,UAAU;EACV;IACE,iBAAiB;IACjB,SAAS;IACT,cAAc;EAChB;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,YAAY;EACZ;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;EACX;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA,oBAAoB;EACpB;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB","sourcesContent":["/* Main Container */\n.wiki-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 10px;\n    color: #333;\n    font-family: Arial, sans-serif;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    background-color: #fff;\n  }\n  \n  /* Header */\n  .wiki-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n  }\n  \n  /* Title */\n  .wiki-title {\n    font-size: 1.5rem;\n    margin: 0;\n    color: #007bff;\n  }\n  \n  /* Image Placeholder */\n  .wiki-image-placeholder {\n    flex: 0 0 50%;\n    height: 80px;\n    background-color: #e9ecef;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #888;\n    font-size: 0.9rem;\n    border-radius: 5px;\n  }\n  \n  /* Infobox */\n  .wiki-infobox {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 10px 15px;\n    font-size: 0.9rem;\n    margin-bottom: 10px;\n    gap: 10px;\n  }\n  \n  /* Content Grid */\n  .wiki-content {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n  }\n  \n  /* Section Styling */\n  .wiki-section {\n    background-color: #f8f8f8;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 0.9rem;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
